<template>
    <dash
        icon="fa fa-users"
        titulo="USUÁRIOS"
        @click.native="$router.push({ name: 'Fornecedores_Usuarios' })"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
	components: {
		Dash
	},

	data() {
		return {}
	}
}
</script>
